import {StyleSheet} from 'react-native';

export default StyleSheet.create({
    container: {
        flex: 1,
    },
    slideContainer: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height:undefined,
        aspectRatio: 5/7
    },
    slideText: {
        textAlign:'center',
        fontFamily: 'Raleway',
        fontSize: 32,
        'color': '#ffffff'
    },
    slideTextHolder: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        justifyContent: 'center',
        alignItems: 'center'
    },
    slideTextBG: {
      backgroundColor:'#77777747',
      padding:5
    }
})